import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const RulesGeneratorModalContainer = styled.div<{ theme: { token: GlobalToken } }>`
  padding: ${({ theme: { token } }) => `${token.paddingXL}px`};
  display: flex;
  flex-direction: column;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  width: 1032px;

  /* hide number input arrows - Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* hide number input arrows - Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }

  .ok-button {
    align-self: flex-end;
  }

  .table-container {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .rule-name {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      color: ${({ theme: { token } }) => token.colorPrimary};
      margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }

    .rule-name-input {
      width: fit-content;
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      color: ${({ theme: { token } }) => token.colorPrimary};
      margin-bottom: ${({ theme: { token } }) => token.marginLG}px;

      &::placeholder {
        color: ${({ theme: { token } }) => token.colorPrimary};
      }
    }

    .default-setpoints {
      padding: 0;
      margin-top: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }
`;
